import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["snackbar-container", {'error' : _ctx.error, 'show':_ctx.show, 'above-bottom-menu':_ctx.aboveBottomMenu} ])
  }, [
    _createElementVNode("p", null, _toDisplayString(_ctx.text), 1)
  ], 2))
}